export interface AfterTideEligibilityResult {
  isEligible: boolean
  reasons: string[]
}

export function checkAfterTideEligibility(params: {
  spiceLevel?: number
  darknessLevel?: number
  genre?: string
  mainSubgenre?: string
  selectedSubGenres?: string[]
  ageRating?: string
  contentWarnings?: string[]
}): AfterTideEligibilityResult {
  const reasons: string[] = []

  // 1. Spice Level
  if (params.spiceLevel && params.spiceLevel >= 4) {
    reasons.push(`Spice level ${params.spiceLevel} qualifies for AfterTide`)
  }

  // 2. Darkness Level
  if (params.darknessLevel && params.darknessLevel >= 3) {
    reasons.push(
      `Darkness level ${params.darknessLevel} qualifies for AfterTide`,
    )
  }

  // 3. Subgenres
  const eligibleSubgenres = [
    'Dark Romance',
    'Erotic Romance',
    'Monster Romance',
    'Mafia Romance',
    'Horror',
    'Horror Erotica',
    'Science Fiction Erotica',
    'Paranormal Romance',
    'Gothic Horror',
    'Body Horror',
  ]

  const allSubgenres = [
    params.mainSubgenre,
    ...(params.selectedSubGenres || []),
  ].filter(Boolean) as string[]

  for (const subgenre of allSubgenres) {
    if (eligibleSubgenres.includes(subgenre)) {
      reasons.push(`Subgenre "${subgenre}" qualifies for AfterTide`)
    }
  }

  // 4. Content Warnings
  const eligibleWarnings = [
    'Non-consent',
    'Dubious consent',
    'Somnophilia',
    'Graphic violence',
    'Torture',
    'Gore',
    'Blood play',
  ]

  for (const warning of params.contentWarnings || []) {
    if (eligibleWarnings.includes(warning)) {
      reasons.push(`Content warning "${warning}" qualifies for AfterTide`)
    }
  }

  // 5. Age Rating
  if (params.ageRating === '18+') {
    reasons.push('18+ age rating qualifies for AfterTide')
  }

  return {
    isEligible: reasons.length > 0,
    reasons,
  }
}
